import {isNotEmpty} from "./tools";
import {LoginInfo} from "@/apis/auth";

const getAccessToken = (): string => {
  try {
    return localStorage.getItem("accessToken") || "";
  } catch (e) {
    return "";
  }
};
const getRefreshToken = (): string => {
  try {
    return localStorage.getItem("refreshToken") || "";
  } catch (e) {
    return "";
  }
};
const isLogin = (): boolean => {
  return isNotEmpty(getRefreshToken());
};
const logout = (): void => {
  localStorage.removeItem("toPath");
  localStorage.removeItem("user");
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("secret");
  localStorage.removeItem("paymentId");
  location.href = location.origin + "/";
};

const handleLoginSuccess = (loginInfo: LoginInfo): void => {
  const {refreshToken, accessToken, secret, ...rest} = loginInfo
  localStorage.setItem('user', JSON.stringify(rest))
  localStorage.setItem("refreshToken", refreshToken);
  localStorage.setItem("accessToken", accessToken);
  localStorage.setItem("secret", secret);
}

export {getAccessToken, getRefreshToken, isLogin, logout, handleLoginSuccess};
